import * as React from "react";
import { useContext } from 'react';
import { AuthContext } from 'src/components/context/AuthContext';
import CommissionCalculationDescriptionButton from 'src/pages/monitor/my-quotes/commission-information/CommissionCalculationDescriptionButton';
import { IPricing } from "src/services/interfaces/calculator/IPricing";
import { formatCurrency } from "src/util/Masks/formatCurrency";

import { PercentageMask } from "src/util/Masks/PercentageMask";
export const PricingResultCommission = (props: { pricing: IPricing, showAllData: boolean }) => {

  const { currentUser } = useContext(AuthContext);

  return (
    <>
      <span className="subtitle">Comissões {currentUser.permissions.canViewCommissionDetail && <CommissionCalculationDescriptionButton pricing={props.pricing} />}</span>
      <div className="region-container">
        {currentUser.officer.isOfficerDecode && (
          <div className="row">
            <span className="left description">Valor Comissão Decode (Padrão):</span>
            <span className="right description">{`${formatCurrency(props.pricing?.commission?.decode?.value)} (${(PercentageMask(props.pricing?.commission?.decode?.percentage, 2, 2))})`}</span>
          </div>
        )}

        <div className="row">
          <span className="left description">Comissão:</span>
          <span className="right description">{PercentageMask(props.pricing?.commission?.officer?.userCommissionCalculated?.percentage ?? props.pricing?.commission?.officer?.full?.percentage, 2, 2)}</span>
        </div>
        <div className="row">
          <span className="left description">Valor de Comissão:</span>
          <span className="right description">{formatCurrency(props.pricing?.commission?.officer?.userCommissionCalculated?.value ?? props.pricing?.commission?.officer?.full?.value)}</span>
        </div>
        {props.pricing?.minCommissionValue !== 0 && props.showAllData &&
          <div className="row">
            <span className="left description">Valor de Comissão Mínimo:</span>
            <span className="right description">{formatCurrency(props.pricing?.commission?.officer?.userCommissionCalculated?.minValue ?? props.pricing?.commission?.officer?.full?.minValue)}</span>
          </div>
        }
        {props.pricing?.maxCommissionValue !== 0 && props.showAllData &&
          <div className="row">
            <span className="left description">Valor de Comissão Máximo:</span>
            <span className="right description">{formatCurrency(props.pricing?.commission?.officer?.userCommissionCalculated?.maxValue ?? props.pricing?.commission?.officer?.full?.maxValue)}</span>
          </div>
        }
      </div>
    </>
  )
}


// WEBPACK FOOTER //
// ./src/components/common/pricing-result/PricingResultCommission.tsx